import type { IZendeskChatApi } from '@type/Zendesk';
import { iocNames } from '../iocNames';
import { useDynamicInject } from './useInject';

export const useZendeskApi = () => {
  return useDynamicInject<IZendeskChatApi>(iocNames.zendeskWidget);
};
